<template lang="html">
  <!-- eslint-disable vue/no-v-html -->
  <div ref="jobMarkup" v-html="job.body" />
</template>

<script>
import { mapActions } from 'vuex'
import _debounce from 'lodash-es/debounce'

export default {
  props: {
    job: { type: Object, required: true }
  },
  watch: {
    job: {
      handler(job) {
        if (job) {
          // We need to delay this call until the markup has been rendered and is available in $refs
          this.$nextTick(() => {
            this.placeJobwareResponsiveClasses()
            this.addCriteoEventListener()
          })
        }
      }
    }
  },
  mounted() {
    // We need to import this dynamically because the foundation code is not universal and can't be loaded in SSR.
    const {
      MediaQuery
    } = require('foundation-sites/js/foundation.util.mediaQuery')
    this.mediaQuery = MediaQuery
    window.addEventListener(
      'resize',
      _debounce(this.placeJobwareResponsiveClasses, 100)
    )
    this.placeJobwareResponsiveClasses()
    this.addCriteoEventListener()
  },
  methods: {
    ...mapActions(['trackGoogleTagManagerEvent']),
    placeJobwareResponsiveClasses() {
      // Jobware needs us to provide some hints for their responsive layouts. This is done with the following classes
      // depending on the current breakpoint.
      if (!this.$refs.jobMarkup) {
        return
      }
      const wrapper = this.$refs.jobMarkup
        .getElementsByClassName('jw-wrapper-responsive')
        .item(0)
      if (!wrapper) {
        return
      }

      const current = `jw-${this.mediaQuery.current}`
      wrapper.classList.remove('jw-small', 'jw-medium', 'jw-large')
      wrapper.classList.add(current)
    },
    addCriteoEventListener() {
      // trigger criteo event for jobware "klickout" links
      const links = this.$refs.jobMarkup.querySelectorAll(
        'a[data-klickout=apply]'
      )

      if (links && links.length > 0) {
        links.forEach(link =>
          link.addEventListener('click', () =>
            this.trackGoogleTagManagerEvent({ action: 'applicationIntent' })
          )
        )
      }
    }
  }
}
</script>
